import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { ArrowLeft, UserPlus, Mail } from 'lucide-react';
const UserCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    luogo: '',
    obiettivi: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate user creation
    alert(`Utente creato con successo!\n\nNome: ${formData.nome} ${formData.cognome}\nEmail: ${formData.email}\n\nUn'email di invito è stata inviata all'utente.`);
    navigate('/users');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-4080">
      <div className="w-20 flex-shrink-0" data-id="element-4081">
        <Sidebar data-id="element-4082" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4083">
        <Topbar data-id="element-4084" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-4085">
          {/* Back Button */}
          <button onClick={() => navigate('/users')} className="flex items-center text-gray-600 hover:text-greenback mb-4 transition-colors" data-id="element-4086">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-4087" />
            Torna agli Utenti
          </button>

          {/* Page Header */}
          <div className="mb-6" data-id="element-4088">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-4089">
              Aggiungi Nuovo Utente
            </h1>
            <p className="text-gray-600" data-id="element-4090">
              Invita un nuovo utente sulla piattaforma Greenback
            </p>
          </div>

          {/* Form */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 max-w-2xl" data-id="element-4091">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-4092">
              {/* Nome e Cognome */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4093">
                <div data-id="element-4094">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4095">
                    Nome <span className="text-red-500" data-id="element-4096">*</span>
                  </label>
                  <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Es. Mario" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-4097" />
                </div>

                <div data-id="element-4098">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4099">
                    Cognome <span className="text-red-500" data-id="element-4100">*</span>
                  </label>
                  <input type="text" name="cognome" value={formData.cognome} onChange={handleChange} required placeholder="Es. Rossi" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-4101" />
                </div>
              </div>

              {/* Email */}
              <div data-id="element-4102">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4103">
                  Email <span className="text-red-500" data-id="element-4104">*</span>
                </label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mario.rossi@email.it" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-4105" />
                <p className="text-sm text-gray-500 mt-1" data-id="element-4106">
                  L'utente riceverà un'email di invito a questo indirizzo
                </p>
              </div>

              {/* Luogo */}
              <div data-id="element-4107">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4108">
                  Città
                </label>
                <input type="text" name="luogo" value={formData.luogo} onChange={handleChange} placeholder="Es. Milano" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-4109" />
              </div>

              {/* Obiettivi */}
              <div data-id="element-4110">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4111">
                  Obiettivi Sostenibilità
                </label>
                <select name="obiettivi" value={formData.obiettivi} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-greenback focus:border-transparent" data-id="element-4112">
                  <option value="" data-id="element-4113">Seleziona un obiettivo...</option>
                  <option value="Ridurre plastica" data-id="element-4114">Ridurre plastica</option>
                  <option value="Vita sostenibile" data-id="element-4115">Vita sostenibile</option>
                  <option value="Zero waste" data-id="element-4116">Zero waste</option>
                  <option value="Cosmetici naturali" data-id="element-4117">Cosmetici naturali</option>
                  <option value="Mobilità green" data-id="element-4118">Mobilità green</option>
                  <option value="Alimentazione bio" data-id="element-4119">Alimentazione bio</option>
                  <option value="Energia rinnovabile" data-id="element-4120">
                    Energia rinnovabile
                  </option>
                  <option value="Ridurre sprechi" data-id="element-4121">Ridurre sprechi</option>
                  <option value="Vita green" data-id="element-4122">Vita green</option>
                  <option value="Riciclo attivo" data-id="element-4123">Riciclo attivo</option>
                </select>
              </div>

              {/* Info Box */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-4124">
                <div className="flex items-start gap-3" data-id="element-4125">
                  <Mail className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-4126" />
                  <div data-id="element-4127">
                    <h4 className="font-semibold text-blue-900 mb-1" data-id="element-4128">
                      Email di Invito
                    </h4>
                    <p className="text-sm text-blue-700" data-id="element-4129">
                      Dopo aver creato l'utente, verrà inviata automaticamente
                      un'email di invito con le istruzioni per accedere alla
                      piattaforma Greenback.
                    </p>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex gap-3 pt-4" data-id="element-4130">
                <button type="button" onClick={() => navigate('/users')} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-4131">
                  Annulla
                </button>
                <button type="submit" className="flex items-center gap-2 px-6 py-2 bg-greenback text-white rounded-lg hover:bg-green-700 transition-colors" data-id="element-4132">
                  <UserPlus className="h-4 w-4" data-id="element-4133" />
                  Crea Utente e Invia Invito
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>;
};
export default UserCreate;